import { Component, OnInit } from '@angular/core'

import { SESSION_STORAGE_CONSTANTS_CAAS_CONTENT } from '../../../../constants/constant.content'

@Component({
  selector: 'fd3-banner-error',
  templateUrl: './banner-error.component.html',
  styleUrls: ['./banner-error.component.scss'],
})
export class BannerErrorComponent implements OnInit {
  fd3ErrorList: any
  aemCassDataFromSession: string
  ngOnInit(): void {
    this.aemCassDataFromSession = sessionStorage.getItem(
      SESSION_STORAGE_CONSTANTS_CAAS_CONTENT,
    )

    this.fd3ErrorList = JSON.parse(
      this.aemCassDataFromSession,
    ).data.fd3errorsList.items[0]
  }
}
